import z from 'zod';

import { ETaskDueDateStatus } from '@enums/task.enum';

export const getAllTasksSchema = z.object({
  dueDateStatus: z
    .enum(ETaskDueDateStatus)
    .array()
    .default([ETaskDueDateStatus.Overdue, ETaskDueDateStatus.DueToday])
    .optional(),
  showAll: z.boolean().optional(),
});

export type GetAllTasksParams = z.infer<typeof getAllTasksSchema>;
